export const CalmLogoColor = { White: 'White', Gradient: 'Gradient' };
//# sourceMappingURL=types.js.map